export default __webpack_public_path__ + "static/media/github.11e802bf.svg";